import { render } from "./TradePermitWithNoLogo.vue?vue&type=template&id=7c2e9a8e&scoped=true"
import script from "./TradePermitWithNoLogo.vue?vue&type=script&lang=js"
export * from "./TradePermitWithNoLogo.vue?vue&type=script&lang=js"

import "./TradePermitWithNoLogo.vue?vue&type=style&index=0&id=7c2e9a8e&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2e9a8e"]])

export default __exports__